/* ========================================================================
 * Checkout / Basket page
 * ======================================================================== */

"use strict";

import $ from "jquery";
import Basket from "./basket";
import General from "./general";

export default function() {
	var phase         = $(".checkout .phase-basket"),
		$alertArea    = $(".basket-alert-area"),
		ajaxEndpoints = {
			discountCode: "/ajax/discountcode/"
		};

	//Rest is only for checkout basket stage page

	if (phase.length === 0) { return; }

	if ((sessionStorage && sessionStorage.getItem("closedBasketExpirationCheckout") !== "true") || !sessionStorage) {
		const checkoutExpirationNotice = document.querySelector(".checkout .expiration-notice");
		if (checkoutExpirationNotice) {
			checkoutExpirationNotice.style.display = "block";
		}
	}

	const closeExpirationNoticeBtn = document.querySelector(".checkout .expiration-notice .component-close-button");
	if (closeExpirationNoticeBtn) {
		closeExpirationNoticeBtn.addEventListener("click", function () {
			const closeExpirationNotice = document.querySelector(".checkout .expiration-notice.components");
			if (closeExpirationNotice) {
				if (sessionStorage) {
					sessionStorage.setItem("closedBasketExpirationCheckout", "true");
				}
				closeExpirationNotice.parentNode.removeChild(closeExpirationNotice);
			}
		});
	}


	//Removing items from basket
	var removing = false;
	$(phase).on("submit", ".item-remove", function(e) {

		e.preventDefault();

		//Prevent double clicks
		if(removing) {
			return false;
		}

		removing = true;

		var $item = $(this).closest(".basket-item");

		if($item.is(".product")) {

			var productParams = {
				id: $item.data("id"),
				name: $item.data("name"),
				price: $item.data("price"),
				brand: $item.data("brand"),
				category: $item.data("category"),
				color: $item.data("variant"),
				ean: $item.data("ean"),
				size: $item.data("size"),
				amount: $item.data("amount"),
				colorId: $item.data("color")
			};

			Basket.removeProduct(productParams, false, function() {
				//Success
				removing = false;
			}, function() {
				//Error
				removing = false;
			});

		} else if($item.is(".package")) {

			var reservationUuid = $item.data("uuid");

			Basket.removePackage(reservationUuid, false, function() {
				//Success
				removing = false;
			}, function() {
				//Error
				removing = false;
			});
		}

		return false;

	});

	//Changing amount of items in basket
	var debounceTimer,
		amountRunner = false;
	$(phase).on("keyup", ".amount", function() {

		clearTimeout(debounceTimer);

		var $input     = $(this),
			$item      = $input.closest(".basket-item"),
			newAmount  = parseInt($input.val());

		debounceTimer = setTimeout(function() {

			//Prevent double clicks while running previous action
			if(amountRunner) {
				return false;
			}


			if (!isNaN(newAmount)) {
				amountRunner = true;
				$input.prop("disabled", true);
			} else {
				return false;
			}

			//Check that amount is a number
			if(!isNaN(newAmount)) {

				//Only products have amount field, packages don't have
				if($item.is(".product")) {

					var ean = $item.data("ean");

					Basket.updateProductAmount(ean, newAmount, function(data) {
						//Success
						amountRunner = false;
						$input.prop("disabled", false);

						if(data.basket.items.length) {
							General.showAlert(data.txt, $alertArea, "success", 3000);
						}

					}, function(data) {
						//Error
						amountRunner = false;
						$input.prop("disabled", false);

						General.showAlert(data.txt, $alertArea, "danger", 3000);
					});

				}

			}

		}, 400);
	});

	//Empty basket 

	$(phase).on("submit", "form.empty-basket", function(e) {
		e.preventDefault();

		Basket.empty();

		return false;
	});

	//Discount codes

	$(phase).on("submit", "form.discount-code", function(e) {
		e.preventDefault();

		var $form = $(this);

		$.ajax({
			url: ajaxEndpoints.discountCode,
			data: {
				action: $form.find('input[name="action"]').val(),
				code: $form.find('input[name="code"]').val(),
				token: General.getToken()
			},
			success: function(data) {
				if(data.status === "SUCCESS") {
					Basket.refresh();
				} else if(data.status === "ERROR") {
					//In case of error, show alert
					General.showAlert(data.txt, $form, "danger");
				}
			}
		});

		return false;
	});

}
